import { checkPermission } from "../permissions/usePermissions"

export const datastakeRole = {
  pme: {
    pmeIA: {
      dashboard: true,
      scl: false,
      village: false,
      informationSources: false,
      profile: true,
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
        scp: {
          create: true,
          edit: true
        }
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      events: {
        create: true,
        edit: true
      },
      documents: {
        create: true,
        edit: true
      },
      network: {
        lir: {
          create: true,
          edit: true
        },
        informationSources: {
          create: false,
          edit: false
        },
        governance: {
          create: true,
        }
      },
      projects: {
        create: true,
        edit: true,
        inviteCustomer: true,
        inviteSupplier: false,
      },
    },
    pmeMEC: {
      dashboard: true,
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
        scp: {
          create: true,
          edit: true
        }
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      events: {
        create: true,
        edit: true
      },
      projects: {
        create: true,
        edit: true,
        inviteCustomer: true,
        inviteSupplier: true,
      },
      network: {
        informationSources: {
          create: true,
          edit: true
        },
        lir: {
          create: true,
          edit: true
        }
      },
      documents: {
        create: true,
        edit: true
      },
      // scl: {
      //   create: false,
      //   edit: false
      // },
      // village: {
      //   create: false,
      //   edit: false
      // },
      // scp: {
      //   create: false,
      //   edit: false
      // },
      // event: {
      //   create: false,
      //   edit: false
      // },
      addInfo: false,
      profile: true
    }
  },
  cadd: {
    caddSeller: {
      dashboard: true,
      projects: {
        create: true,
        edit: true,
        delete: false,
        view: true,
        inviteCustomer: true,
        inviteSupplier: false,
      },
      profile: true,
      kyc: true,
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      documents: {
        create: true,
        edit: true
      },
      addInfo: {
        scl: {
          create: true,
          edit: true,
          delete: false,
          view: true
        },
        village: {
          create: true,
          edit: true,
          delete: false,
          view: true
        },
        scp: {
          create: true,
          edit: true,
          delete: false,
          view: true
        },
        stk: {
          create: true,
          edit: true,
          delete: false,
          view: true
        },
        event: {
          create: true,
          edit: true,
          delete: false,
          view: true
        },
        all: {
          create: true,
          edit: true,
          delete: true,
          view: true
        }
      },
      network: {
        lir: {
          create: true,
          edit: true
        },
        informationSources: {
          create: false,
          edit: false
        },
        governance: {
          create: true,
        }
      },
      events: {
        create: true,
        edit: true
      },
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      governance: true,
      shipments: true,
      risk: true,
    },
    caddBuyer: {
      dashboard: true,
      projects: {
        create: true,
        edit: true,
        delete: false,
        view: true,
        inviteCustomer: true,
        inviteSupplier: true,
      },
      documents: {
        create: true,
        edit: true
      },
      profile: true,
      kycBuyer: true,
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      network: {
        lir: {
          create: true,
          edit: true
        },
        informationSources: {
          create: false,
          edit: false
        },
        governance: {
          create: true,
        }
      },
      countries: {
        scl: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        village: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        scp: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        stk: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        event: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        ais: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        all: {
          create: true,
          edit: true,
          delete: true,
          view: true
        }
      },
      events: {
        create: true,
        edit: true
      },
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      governance: true,
      shipments: true,
      risk: true,
    },
    caddIcscp: {
      documents: {
        create: true,
        edit: true
      },
      dashboard: true,
      projects: {
        create: true,
        edit: true,
        delete: false,
        view: true,
        inviteCustomer: true,
        inviteSupplier: true,
      },
      profile: true,
      kycBuyer: true,
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      network: {
        lir: {
          create: true,
          edit: true
        },
        informationSources: {
          create: false,
          edit: false
        },
        governance: {
          create: true,
        }
      },
      countries: {
        scl: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        village: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        scp: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        stk: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        event: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        ais: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        all: {
          create: true,
          edit: true,
          delete: true,
          view: true
        }
      },
      events: {
        create: true,
        edit: true
      },
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      governance: true,
      shipments: true,
      risk: true,
    },
    caddIscp: {
      documents: {
        create: true,
        edit: true
      },
      dashboard: true,
      projects: {
        create: true,
        edit: true,
        delete: false,
        view: true,
        inviteCustomer: true,
        inviteSupplier: true,
      },
      profile: true,
      kycBuyer: true,
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      network: {
        lir: {
          create: true,
          edit: true
        },
        informationSources: {
          create: false,
          edit: false
        },
        governance: {
          create: true,
        }
      },
      countries: {
        scl: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        village: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        scp: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        stk: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        event: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        ais: {
          create: false,
          edit: false,
          delete: false,
          view: true
        },
        all: {
          create: true,
          edit: true,
          delete: true,
          view: true
        }
      },
      events: {
        create: true,
        edit: true
      },
      stakeholders: {
        all: {
          create: true,
          edit: true
        },
      },
      locations: {
        all: {
          create: true,
          edit: true
        },
        scl: {
          create: true,
          edit: true
        },
        village: {
          create: true,
          edit: true
        },
      },
      governance: true,
      shipments: true,
      risk: true,
    }
  }
}
export const datastakeDisabledFeatuers = {
  pme: {
    pmeIA: {
    },
    pmeMEC: {}
  },
  cadd: {
    caddSeller: {
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      countries: {
        ais: true,
      },
      governance: true,
      shipments: true,
      ais: true,
      risk: true,
    },
    caddBuyer: {
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      countries: {
        ais: true,
      },
      risk: true,
    },
    caddIcscp: {
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      countries: {
        ais: true,
      },
      risk: true,
    },
    caddIscp: {
      systems: {
        supplyPolicy: true,
        managementSystems: true,
        supplyIntegrity: true,
        partnerEngagement: true,
        grievanceMechanism: true,
      },
      countries: {
        ais: true,
      },
      risk: true,
    }
  }
}

export const datastakeModuleLanding = {
  pme: {
    pmeIA: '/app/pme',
    pmeIS: '/app/pme',
    pmeMEC: '/app/pme',
  },
  cadd: {
    caddSeller: '/app/cadd',
    caddBuyer: '/app/cadd',
    caddIcscp: '/app/cadd',
    caddIscp: '/app/cadd',
  }
}
export const getRoleByModule = ({ user, module }) => {
  if (!user || !user.modules || !user.modules[module]) {
    return {}
  }
  return user.modules[module];
}
export const getUserRoleByModule = ({ user, module }) => {
  if (!user || !user.modules || !user.modules[module] || !datastakeRole[module]) {
    return {}
  }
  const moduleRoles = datastakeRole[module];
  return moduleRoles[user.modules[module].role] || {};
}
export const getUserDFByModule = ({ user, module }) => {
  if (!user || !user.modules || !user.modules[module] || !datastakeDisabledFeatuers[module]) {
    return {}
  }
  const moduleRoles = datastakeDisabledFeatuers[module];
  return moduleRoles[user.modules[module].role] || {};
}
export const getModuleFeature = ({ user, module, feature, subfeature }) => {
  const moduleRole = getUserRoleByModule({ user, module });
  return subfeature ? (moduleRole[feature] ? moduleRole[feature][subfeature] : false) : moduleRole[feature]
}

export const checkIfFeatureIsDisabled = ({ user, module, feature, subfeature }) => {
  const df = getUserDFByModule({ user, module });
  return subfeature ? (df[feature] ? df[feature][subfeature] : false) : df[feature]
}
export const canViewFeatureAction = ({ user, module, feature, subfeature, action, view }) => {
  if (action === 'create') {
    switch (feature) {
      case 'lir':
      case 'network':
        return checkPermission({ permission: 'stakeholders.LIR.canCreate', permissions: user?.role?.permissions });
      case 'stakeholders':
        if (view === 'scp') {
          return checkPermission({ permission: 'stakeholders.SCA.canCreate', permissions: user?.role?.permissions });
        }
        return checkPermission({ permission: 'stakeholders.canCreate', permissions: user?.role?.permissions });
      case 'locations':
        if (view === 'village') {
          return checkPermission({ permission: 'locations.villages.canCreate', permissions: user?.role?.permissions });
        }
        return checkPermission({ permission: 'locations.canCreate', permissions: user?.role?.permissions });
      case 'scl':
        return checkPermission({ permission: 'locations.mineSites.canCreate', permissions: user?.role?.permissions });
      case 'events':
      case 'event':
        if (view === 'incidents') {
          return checkPermission({ permission: 'events.incidents.canCreate', permissions: user?.role?.permissions });
        }
        if (view === 'corrective-actions') {
          return checkPermission({ permission: 'events.correctiveActions.canCreate', permissions: user?.role?.permissions });
        }
        return checkPermission({ permission: 'events.canCreate', permissions: user?.role?.permissions });
      case 'documents':
        return checkPermission({ permission: 'documents.canCreate', permissions: user?.role?.permissions });
      default:
        console.log('not found ', feature, view);
    }
  }

  const featureModule = getModuleFeature({ user, module, feature, subfeature });
  return typeof featureModule === 'object' ? featureModule[action] : false;
}

export const getLandingPage = ({ user, module }) => {
  if (!user || !user.modules || !user.modules[module] || !datastakeModuleLanding[module]) {
    return ''
  }
  const modulePaths = datastakeModuleLanding[module];
  return modulePaths[user.modules[module].role] || '';
}
